import gql from "graphql-tag";

import type {ApolloGqlClient} from "@repo/data-gql-apollo";
import {gqlOp, type GqlOperation} from "@repo/data-gql-core";

type Data = {
    user:
        | {
              isActor?: boolean;
              isCoachedByActor?: boolean;
              actorHasUserScopedPermission?: boolean;
          }
        | null
        | undefined;
};

export const IS_ACTIVITY_ACCESSIBLE_QUERY: GqlOperation<Data> = gqlOp(gql`
    query isActivityAccessibleForProfiles {
        user {
            id
            isActor
            isCoachedByActor
            actorHasUserScopedPermission(capability: CAN_VIEW_USER_PROGRESS)
        }
    }
`);

export function isActivityAccessibleFromQueryResults(
    data?: Data | null,
): boolean {
    if (!data || !data.user) {
        return false;
    }
    return Boolean(
        data.user.isActor ||
            data.user.isCoachedByActor ||
            data.user.actorHasUserScopedPermission,
    );
}

export function isActivityAccessible(
    gqlClient: ApolloGqlClient,
): Promise<boolean> {
    return gqlClient
        .query(IS_ACTIVITY_ACCESSIBLE_QUERY, {
            fetchPolicy: "network-only",
        })
        .then((result) => isActivityAccessibleFromQueryResults(result.data));
}
